<ion-header [translucent]="true">
  <ion-toolbar color="primary">
    <ion-buttons slot="start"><ion-menu-button></ion-menu-button></ion-buttons>
    <ion-title>Beadandók</ion-title>
  </ion-toolbar>
</ion-header>

<ion-content>
  <div class="bd-lap">
    <p class="bd-lead">
      Beadandó feladat egy órához (a naplóban az óránál: „Beadandó kiadása”) vagy egy osztálynak/csoportnak.
      A tanulók a „Feladataim” menüben adják be (szöveg és fájl), a szülők látják. Új feladatról és a
      visszajelzésről értesítést kapnak. A visszajelzés és az értékelés szöveges – jegyet a napló Értékelés
      képernyőjén írj be.
    </p>

    <!-- ÚJ FELADAT -->
    <ion-card>
      <ion-card-header class="bd-fej" (click)="ujNyitva = !ujNyitva">
        <ion-card-title>
          <ion-icon [name]="ujNyitva ? 'chevron-down' : 'chevron-forward'" aria-hidden="true"></ion-icon>
          Új beadandó feladat
        </ion-card-title>
      </ion-card-header>
      <ion-card-content *ngIf="ujNyitva">
        <div class="bd-ora" *ngIf="ujOra">
          <ion-icon name="school-outline" aria-hidden="true"></ion-icon>
          <span>Óra: <b>{{ oraLeiras(ujOra) }}</b> – a címzett az óra névsora.</span>
          <ion-button size="small" fill="clear" (click)="oraElvetes()">Másik osztály/csoport</ion-button>
        </div>
        <!-- Mint az Értékeléseknél: külön osztály/csoport és tantárgy, kereshetően; a tantárgy az
             egység tárgyaira szűkül, és ha egy van, kitöltődik. -->
        <div class="bd-valasztok" *ngIf="!ujOra && tanitott">
          <ng-select [items]="tanitott" bindValue="ertek" bindLabel="nev" [(ngModel)]="ujTetel"
            (change)="tetelValasztas()" appendTo="body" placeholder="Osztály / csoport*" [notFoundText]="'Nincs találat'"
            [clearable]="false">
            <ng-template ng-option-tmp let-item="item">
              <span>{{ item.nev }}</span>
              <span *ngIf="item.tipus === 'csoport'" class="bd-cimke">csoport</span>
              <span *ngIf="item.helyettesitett && !item.sajat" class="bd-cimke">helyettesített</span>
            </ng-template>
          </ng-select>
          <ng-select [items]="tantargyValasztek" bindValue="id" bindLabel="name" [(ngModel)]="ujTantargy"
            appendTo="body" placeholder="Tantárgy*" [notFoundText]="'Előbb válassz osztályt/csoportot'" [clearable]="false">
          </ng-select>
        </div>
        <ion-item *ngIf="!ujOra && !tanitott">
          <ion-select label="Osztály / csoport · tantárgy" label-placement="stacked" interface="popover"
                      [(ngModel)]="ujEgyseg" placeholder="Válassz">
            <ion-select-option *ngFor="let e of egysegek" [value]="e.kulcs">{{ e.nev }}</ion-select-option>
          </ion-select>
        </ion-item>
        <ion-note color="medium" *ngIf="!ujOra && tanitott && !tanitott.length" class="bd-sugo">
          Nincs olyan osztályod vagy csoportod, amelyben tanítasz – a naplóból, egy órához is kiadhatod.
        </ion-note>
        <ion-note color="medium" *ngIf="!ujOra && !tanitott && !egysegek.length" class="bd-sugo">
          Az elmúlt 90 nap órarendjében nincs saját órád – a naplóból, egy órához is kiadhatod.
        </ion-note>
        <ion-item>
          <ion-input label="Cím*" label-placement="stacked" [(ngModel)]="ujCim" maxlength="200"></ion-input>
        </ion-item>
        <ion-item>
          <ion-textarea label="Leírás" label-placement="stacked" [(ngModel)]="ujLeiras" [autoGrow]="true" rows="3"></ion-textarea>
        </ion-item>
        <ion-item>
          <ion-input label="Határidő*" label-placement="stacked" type="datetime-local" [(ngModel)]="ujHatarido"></ion-input>
        </ion-item>
        <ion-item lines="none">
          <ion-toggle [(ngModel)]="ujKeso" justify="space-between">
            Határidő után is beadható („késve” jelöléssel)
          </ion-toggle>
        </ion-item>
        <ion-item lines="none">
          <ion-label position="stacked">Csatolmány (opcionális, legfeljebb 20 MB)</ion-label>
          <input #ujFajlInput type="file" [accept]="fajlTipusok" (change)="fajlValasztas($event)" class="bd-fajl" />
        </ion-item>
        <ion-button expand="block" (click)="kiadas(ujFajlInput)" [disabled]="kiad">
          <ion-icon slot="start" name="send-outline"></ion-icon>{{ kiad ? 'Kiadás…' : 'Feladat kiadása' }}
        </ion-button>
      </ion-card-content>
    </ion-card>

    <!-- KIVÁLASZTOTT FELADAT -->
    <ion-card *ngIf="reszlet" class="bd-reszlet">
      <ion-card-header>
        <ion-card-subtitle>{{ reszlet.feladat.egyseg }} · {{ reszlet.feladat.tantargy_nev }}</ion-card-subtitle>
        <ion-card-title>{{ reszlet.feladat.cim }}</ion-card-title>
      </ion-card-header>
      <ion-card-content>
        <p class="bd-leiras" *ngIf="reszlet.feladat.leiras">{{ reszlet.feladat.leiras }}</p>
        <p *ngIf="reszlet.feladat.csatolmany">
          <ion-button size="small" fill="outline" (click)="csatolmanyMegnyit()">
            <ion-icon slot="start" name="attach-outline"></ion-icon>{{ reszlet.feladat.csatolmany.nev }}
          </ion-button>
        </p>
        <div class="bd-szerk">
          <ion-item>
            <ion-input label="Határidő" label-placement="stacked" type="datetime-local" [(ngModel)]="szerkHatarido"></ion-input>
          </ion-item>
          <ion-item lines="none">
            <ion-toggle [(ngModel)]="szerkKeso" justify="space-between">Késői beadás engedve</ion-toggle>
          </ion-item>
          <ion-button size="small" (click)="feladatMentes()">Mentés</ion-button>
          <ion-button size="small" color="danger" fill="outline" (click)="feladatTorles()">Feladat törlése</ion-button>
          <ion-button size="small" fill="clear" (click)="bezar()">Bezárás</ion-button>
        </div>
        <h3 class="bd-osszeg">
          Beadva: {{ beadottDb }} / {{ reszlet.tanulok.length }}
          <span *ngIf="reszlet.feladat.lejart" class="bd-lejart">· a határidő lejárt</span>
        </h3>

        <div class="bd-tanulo" *ngFor="let t of reszlet.tanulok">
          <div class="bd-tanulo-fej">
            <b>{{ t.nev }}</b>
            <ion-badge [color]="allapot(t).szin">{{ allapot(t).szoveg }}</ion-badge>
            <span class="bd-ido" *ngIf="t.beadas?.beadva">
              {{ idoKiir(t.beadas.beadva) }}<span *ngIf="t.beadas.elso_beadva && t.beadas.elso_beadva !== t.beadas.beadva"> (első: {{ idoKiir(t.beadas.elso_beadva) }})</span>
            </span>
            <ion-badge color="tertiary" *ngIf="t.beadas?.modositva_visszajelzes_utan">visszajelzés után módosította</ion-badge>
          </div>
          <ng-container *ngIf="t.beadas?.beadva">
            <p class="bd-valasz" *ngIf="t.beadas.szoveg">{{ t.beadas.szoveg }}</p>
            <div class="bd-fajlok" *ngIf="t.beadas.fajlok?.length">
              <ion-chip *ngFor="let f of t.beadas.fajlok" (click)="fajlMegnyit(t, f)" [outline]="true">
                <ion-icon name="document-outline"></ion-icon>
                <ion-label>{{ f.fajlnev }} ({{ meretKiir(f.meret) }})</ion-label>
              </ion-chip>
            </div>
          </ng-container>
          <div class="bd-vj" *ngIf="t.beadas?.id">
            <ion-item>
              <ion-textarea label="Visszajelzés" label-placement="stacked" [(ngModel)]="t.vj" [autoGrow]="true" rows="2"></ion-textarea>
            </ion-item>
            <ion-item class="bd-ert">
              <ion-input label="Értékelés (szöveges, pl. 12/15 pont)" label-placement="stacked" [(ngModel)]="t.ert" maxlength="50"></ion-input>
            </ion-item>
            <ion-button size="small" (click)="visszajelzes(t)" [disabled]="vjMentes[t.oktazon]">
              {{ t.beadas.visszajelezve ? 'Visszajelzés módosítása' : 'Visszajelzés küldése' }}
            </ion-button>
            <ion-note color="medium" *ngIf="t.beadas.visszajelezve">elküldve: {{ idoKiir(t.beadas.visszajelezve) }}</ion-note>
          </div>
        </div>
      </ion-card-content>
    </ion-card>

    <!-- FELADATLISTA -->
    <div class="bd-allapot" *ngIf="toltodik"><ion-spinner name="dots"></ion-spinner><span>Betöltés…</span></div>
    <div class="bd-allapot hiba" *ngIf="!toltodik && hiba"><ion-icon name="alert-circle-outline"></ion-icon><span>{{ hiba }}</span></div>
    <div class="bd-ures" *ngIf="!toltodik && !hiba && !feladatok.length">Még nem adtál ki beadandó feladatot.</div>

    <ion-list *ngIf="feladatok.length">
      <ion-list-header><ion-label>Kiadott feladataim</ion-label></ion-list-header>
      <ion-item *ngFor="let f of feladatok" button (click)="megnyit(f.id)" [class.bd-aktiv]="reszlet?.feladat?.id === f.id">
        <ion-label class="ion-text-wrap">
          <h2>{{ f.cim }}</h2>
          <p>{{ f.egyseg }} · {{ f.tantargy_nev }} · határidő: {{ idoKiir(f.hatarido) }}<span *ngIf="f.lejart"> (lejárt)</span></p>
        </ion-label>
        <div slot="end" class="bd-szamok">
          <ion-badge color="primary" title="beadva / címzett">{{ f.beadott_db }}/{{ f.cimzett_db }}</ion-badge>
          <ion-badge color="warning" *ngIf="f.keso_db" title="késve beadva">{{ f.keso_db }} késve</ion-badge>
          <ion-badge color="success" *ngIf="f.visszajelzett_db" title="visszajelzett">{{ f.visszajelzett_db }} visszajelzés</ion-badge>
        </div>
      </ion-item>
    </ion-list>
  </div>
</ion-content>
